import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "caac-flypage-flyBasicInfo" }
const _hoisted_2 = { class: "inner-content" }
const _hoisted_3 = { class: "flying-info-item" }
const _hoisted_4 = { class: "flying-info-item" }
const _hoisted_5 = { class: "flying-info-item" }
const _hoisted_6 = {
  key: 0,
  class: "flying-info-item"
}
const _hoisted_7 = { class: "flying-info-item" }




export default /*@__PURE__*/_defineComponent({
  __name: 'flyBasicInfo',
  props: {
    altitude: {
        type: [Number, String],
        default: 0
    },
    horizonalSpeed: {
        type: [Number, String],
        default: 0
    },
    courseAngle: {
        type: [Number, String],
        default: 0
    },
    angularSpeed: {
        type: [Number, String],
        default: 0
    },
    realTimeAngleOffset:{
        type: [Number, String],
        default: undefined
    },
    isMouseHidden: {
        type: Boolean,
        default: false
    },
    isShowFlightInfo: {
        type: Boolean,
        default: true
    }
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.isShowFlightInfo)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "flying-info-container",
          style: _normalizeStyle({ cursor: props.isMouseHidden ? 'none !important' : 'default !important' })
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "info-title" }, "高度", -1)),
              _createElementVNode("p", null, [
                _createElementVNode("span", null, _toDisplayString(props.altitude), 1),
                _cache[0] || (_cache[0] = _createElementVNode("span", null, "m", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "info-title" }, "速度", -1)),
              _createElementVNode("p", null, [
                _createElementVNode("span", null, _toDisplayString(props.horizonalSpeed), 1),
                _cache[2] || (_cache[2] = _createElementVNode("span", null, "m/s", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "info-title" }, "航向角", -1)),
              _createElementVNode("p", null, [
                _createElementVNode("span", null, _toDisplayString(props.courseAngle), 1),
                _cache[4] || (_cache[4] = _createElementVNode("span", null, "°", -1))
              ])
            ]),
            (props.realTimeAngleOffset !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "info-title" }, "航向夹角", -1)),
                  _createElementVNode("p", null, [
                    _createElementVNode("span", null, _toDisplayString(props.realTimeAngleOffset), 1),
                    _cache[6] || (_cache[6] = _createElementVNode("span", null, "°", -1))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "info-title" }, "角速度", -1)),
              _createElementVNode("p", null, [
                _createElementVNode("span", null, _toDisplayString(props.angularSpeed), 1),
                _cache[8] || (_cache[8] = _createElementVNode("span", null, "°/s", -1))
              ])
            ])
          ])
        ], 4))
      : _createCommentVNode("", true)
  ]))
}
}

})